import React from "react";
import { Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function WebsiteHeader() {
  const navigate = useNavigate();

  const handleRedirect = (url) => {
        // Sends the user to the specified external website URL
        window.location.href = url;
    };

  return (
    <header className="w-full bg-white/90 backdrop-blur border-b border-slate-100 sticky top-0 z-50">
      <div className="max-w-[1200px] mx-auto px-4 py-5 flex items-center justify-between">
        <div
          onClick={() => navigate("/")}
          className="flex items-center gap-3 cursor-pointer"
        >
          {/* <div className="w-10 h-10 rounded-xl bg-purple-100 text-purple-700 flex items-center justify-center">
            <Sparkles size={24} />
          </div> */}
          {/* <h1 className="text-2xl font-extrabold m-0">
            ShipLess <span className="text-purple-600">AI</span>
          </h1> */}
          <img width={300} src="https://i.ibb.co/HTJMwrc0/crop-logo-shipless.png"/>
        </div>

        <nav className="hidden lg:flex items-center gap-10 font-semibold text-slate-700">
          <Link to="/how-it-works">How It Works</Link>
          <Link to="/features">Features</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/faq">FAQs</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        <div className="flex items-center gap-3">
          <Button
            className="border-purple-600 text-purple-600 font-semibold"
            onClick={() => handleRedirect('https://dashboard.shipless.in/')}
          >
            Login
          </Button>

          <Button
            type="primary"
            className="bg-purple-600 font-semibold"
            onClick={() => handleRedirect('https://dashboard.shipless.in/')}
          >
            Get Started Free
          </Button>
        </div>
      </div>
    </header>
  );
}